import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OtpInput from "react-otp-input";
import { Link, useHistory } from "react-router-dom";
import Email from "../../img/email.svg";
import CommonService from "./forgetPasswordAPI";
import BackButton from "../../img/icons/icon_blue_back.svg";
import createPersistedState from "use-persisted-state";
import { parseNumberFromAnotherLocale } from "../../utils";

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useMobileState = createPersistedState("mobile");

const CheckMailPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [otp, setOtp] = useState({ otp: "" });
  const [isVerifyingOTP, setOTPVerification] = useState(false);
  const [isVerificationFailed, setVerificationFailure] = useState(false);
  const [isResendingOTP, setIsResendingOTP] = useState(false);
  const [token, setToken] = useTokenState();
  const [pid, _] = usePIDState();
  const [mobile, __] = useMobileState();

  const durationInSeconds = 45;
  let resendTimer = undefined;
  const [isResendOTPBlocked, setIsResentOTPBlocked] = useState(true);
  let [resendCounter, setResendCounter] = useState(durationInSeconds);
  const [waitText, setWaitText] = useState("");

  useEffect(() => {
    // Init
    resendTimer = setInterval(resendOTPBlocker, 1000);
  }, []);

  const resendOTPBlocker = () => {
    setIsResentOTPBlocked(true);
    const _timeUnit = resendCounter === 1 ? "second" : "seconds";
    setWaitText(`Resend OTP in ${resendCounter} ${_timeUnit}`);
    setResendCounter(resendCounter--);
    if (resendCounter === 0) {
      setIsResentOTPBlocked(false);
      setResendCounter(durationInSeconds);
      setWaitText("");
      if (resendTimer !== undefined) clearInterval(resendTimer);
    }
  };

  const onVerifyOtp = async (otp) => {
    return await CommonService.verifyOTP(pid, token, otp);
  };

  const handleChange = (otp) => {
    setOtp({ otp });
    setOTPVerification(false);
    setVerificationFailure(false);

    // verify otp
    if (otp.length === 6) {
      try {
        const otpValue = parseNumberFromAnotherLocale(otp);
        console.log("verifying OTP");
        setOTPVerification(true);
        const response = onVerifyOtp(otpValue);
        if (response !== null) {
          response
            .then((data) => {
              setOTPVerification(false);
              if (data.status.success !== true) {
                setVerificationFailure(true);
              } else {
                setVerificationFailure(false);
                history.push("/create-new-password");
              }
            })
            .catch((err) => {
              setVerificationFailure(true);
            });
        } else {
          setVerificationFailure(false);
        }
      } catch (e) {
        setVerificationFailure(true);
      }
    }
  };

  // fetch resend otp and token from CommonService
  const resendOtp = async () => {
    if (isResendOTPBlocked) return;
    setOTPVerification(false);
    setVerificationFailure(false);
    setOtp({ otp: "" });
    setIsResendingOTP(true);
    const response = await CommonService.getOTP(pid);
    if (response && response.status.code === 200) {
      setToken(response.tid);
    }
    setIsResendingOTP(false);
    resendTimer = setInterval(resendOTPBlocker, 1000);
  };

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link
            to="/forgot-password"
            className="icon_left d-flex align-items-center"
          >
            <img src={BackButton} alt="" className="img-fluid" />
          </Link>
        </div>
      </header>
      <div className="body_content">
        <div className="pwd_content ">
          <div className="thumbnail wow zoomIn">
            <img src={Email} alt="" className="img-fluid" />
          </div>
          <div className="section_title">
            <h4 className="maintitle">
              {t("appointment.FORGET-PASSWORD.message3")}
            </h4>
            <p className="desc">{t("appointment.FORGET-PASSWORD.message4")}</p>
          </div>
          <h4 className="subtitle mb-2">
            {t("onboard.VERIFY_MOBILE.description")}
          </h4>
          <h6 className="subtitle">
            <span className="txt_color_gray">
              ({t("sidenav.MOBILE.sentotp")}{" "}
            </span>
            <span>{mobile}</span>
            <span className="txt_color_gray">)</span>
          </h6>
          <div className="otp_block  d-flex align-items-center">
            <OtpInput
              value={otp.otp}
              onChange={handleChange}
              numInputs={6}
              isInputNum={true}
              inputStyle={{
                width: "2.1rem",
                height: "2.1rem",
                margin: "8px 0.3rem",
                fontSize: "1rem",
                borderRadius: 4,
                border: "2px solid rgba(0,0,0,0.3)",
                marginTop: "8px",
              }}
            />
            {isVerifyingOTP ? (
              <span
                style={{ marginLeft: "1em" }}
                className="icon ml-4 fa-solid fa-spinner fa-spin"
              ></span>
            ) : (
              <></>
            )}

            {isVerificationFailed ? (
              <span
                style={{ marginLeft: "1em", color: "red" }}
                className="icon ml-4 fa-solid fa-xmark"
              ></span>
            ) : (
              <></>
            )}
          </div>
          <div
            className="d-flex"
            style={{ justifyContent: "space-between", marginTop: "1em" }}
          >
            <Link
              to="#"
              onClick={() => {
                setOTPVerification(false);
                setVerificationFailure(false);
                setOtp({ otp: "" });
              }}
              className="link_resend_otp "
              style={{ color: "#0060A6", fontWeight: "500" }}
            >
              {t("sidenav.MOBILE.clearotp")}
            </Link>
            <Link
              to="#"
              className={
                isResendOTPBlocked
                  ? "link_resend_otp disabled-txt "
                  : "link_resend_otp"
              }
              style={{ color: "#0060A6", fontWeight: "500" }}
              onClick={() => resendOtp()}
            >
              {isResendingOTP && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              &nbsp;{t("onboard.VERIFY_MOBILE.resendCTA")}
            </Link>
          </div>
          <br />
          <div className="d-flex justify-content-center">
            <br />
            {isResendOTPBlocked && (
              <span className="txt_help txt_color_orange_2">{waitText}</span>
            )}
          </div>
          <div className="btn_block bottom_button d-flex justify-content-center p-3">
            <button
              className="btn btn_primary"
              disabled={otp.otp.length < 6 || isVerifyingOTP}
              onClick={() => handleChange(otp.otp)}
            >
              {t("appointment.BUTTON.verify")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckMailPage;
